import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const params = {},
    actions = {
        getPermissions: {
            method: 'GET',
            url: `${BASE_PATH_API}/apiManagement/permissions`
        },
        getApiUserRole: {
            method: 'GET',
            url: `${BASE_PATH_API}/apiManagement/userRole`
        },
        getSandboxAccountDetails: {
            method: 'GET',
            url: `${BASE_PATH_API}/openApiSandbox`
        },
        createSandboxAccount: {
            method: 'POST',
            url: `${BASE_PATH_API}/openApiSandbox`
        },
        manageSandboxAccountEligibility: {
            method: 'GET',
            url: `${BASE_PATH_API}/openApiSandbox/accountEligibility`
        },
    };

export function ExternalApiManagementApi() {
    return createActions(actions, params);
}
